// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0272f524","239":"d936cbbe","667":"17cb5ec0"}[chunkId] + ".chunk.js";
};